/** ACDMC primary navigation — permission keys gate visibility in the shell. */
export type AcdmcNavItem = {
  name: string
  href: string
  permission: string | string[]
  /** When true, item is shown only if the path is allowed (feature + permission). */
}

export const ACDMC_NAV_ITEMS: AcdmcNavItem[] = [
  { name: 'Academic dashboard', href: '/acdmc/dashboard', permission: 'acdmc.dashboard.read' },
  { name: 'Curriculum', href: '/acdmc/curriculum', permission: 'acdmc.curriculum.read' },
  { name: 'Publishers & textbooks', href: '/acdmc/publishers', permission: 'acdmc.publishers.read' },
  { name: 'School syllabus', href: '/acdmc/syllabus', permission: 'acdmc.curriculum.read' },
  { name: 'Academic planning', href: '/acdmc/planning', permission: 'acdmc.planning.read' },
  { name: 'Lesson planning', href: '/acdmc/lesson-plan', permission: 'acdmc.classwork.read' },
  { name: 'Teaching tracker', href: '/acdmc/teaching', permission: 'acdmc.teaching.read' },
  { name: 'Homework', href: '/acdmc/homework', permission: 'acdmc.classwork.read' },
  { name: 'Assignments', href: '/acdmc/assignment', permission: 'acdmc.classwork.read' },
  { name: 'Quizzes', href: '/acdmc/quiz', permission: 'acdmc.classwork.read' },
  { name: 'Assessment alignment', href: '/acdmc/assessment-alignment', permission: 'acdmc.assessment.read' },
  { name: 'Academic intelligence', href: '/acdmc/intelligence', permission: 'acdmc.intelligence.read' },
  { name: 'Reports', href: '/acdmc/reports', permission: 'acdmc.reports.read' },
  { name: 'Week overview', href: '/acdmc/overview', permission: ['acdmc.dashboard.read', 'acdmc.classwork.read'] },
]

export const isAcdmcNavVisible = (
  item: AcdmcNavItem,
  can: (keys: string | string[]) => boolean,
  pathAllowed: (href: string) => boolean
) => pathAllowed(item.href) && can(item.permission)
